import { render, staticRenderFns } from "./invite-and-share-categories-section.vue?vue&type=template&id=b579d430&scoped=true"
import script from "./invite-and-share-categories-section.vue?vue&type=script&lang=js"
export * from "./invite-and-share-categories-section.vue?vue&type=script&lang=js"
import style0 from "./invite-and-share-categories-section.vue?vue&type=style&index=0&id=b579d430&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b579d430",
  null
  
)

export default component.exports